export const GET_CIRCUIT_VPN_LOGS = {
    INIT : "GET_CIRCUIT_VPN_LOGS_INIT",
    SUCCESS : "GET_CIRCUIT_VPN_LOGS_SUCCESS",
    ERROR : "GET_CIRCUIT_VPN_LOGS_ERROR",
}

export const GET_CIRCUIT_VPN_DETAILS_BY_EVENTS = {
    INIT : "GET_CIRCUIT_VPN_DETAILS_BY_EVENTS_INIT",
    SUCCESS : "GET_CIRCUIT_VPN_DETAILS_BY_EVENTS_SUCCESS",
    ERROR : "GET_CIRCUIT_VPN_DETAILS_BY_EVENTS_ERROR",
}